import type {
  PaymentDueReminderRuleDto,
  ServiceContractInvoiceRuleDto,
} from '@repo/api';
import { API, BASE, URL_TENANT_SETTINGS, V1 } from '@/lib/constants/urls';
import { client } from '@/api/common';
import { TenantSettings } from '@repo/database/browser';

export const getTenantSetting = async (
  tenantId: string
): Promise<TenantSettings> => {
  const response = await client<TenantSettings>({
    url: `${BASE}${API}${V1}${URL_TENANT_SETTINGS}/${tenantId}`,
    method: 'GET',
  });

  return response.data;
};

export const updateTenantSetting = async (
  tenantId: string,
  data: Partial<TenantSettings> & {
    serviceContractInvoiceRule?: ServiceContractInvoiceRuleDto;
    paymentDueReminderRule?: PaymentDueReminderRuleDto;
  }
): Promise<TenantSettings> => {
  const response = await client<TenantSettings>({
    url: `${BASE}${API}${V1}${URL_TENANT_SETTINGS}/${tenantId}`,
    method: 'PATCH',
    data,
  });

  return response.data;
};
